import React from "react";
import Fade from "react-reveal/Fade";
import { useGetProductsEnAvantQuery } from "../../utils/api/product/product.api";
import BestSellerCatalogGrid from "./BestSellerCatalogGrid";
import type { Product } from "../../utils/api/product/product.type";

const EN_AVANT_LIMIT = 12;

/**
 * Uniquement les produits « mis en avant » (API `en_avants`), pas le catalogue général.
 * La section « NOS PRODUITS » affiche les premiers produits du listing standard.
 */
const BestSellersSection = () => {
  const { data: enAvantData, isLoading } = useGetProductsEnAvantQuery({
    page: 1,
    limit: EN_AVANT_LIMIT,
  });

  const products: Product[] = enAvantData?.results ?? [];

  return (
    <section
      className="best-sellers-section px-lg-3"
      aria-labelledby="best-sellers-heading"
    >
      <div className="best-sellers-section-container">
        <Fade bottom>
          <header className="best-sellers-section-header">
            <h2
              id="best-sellers-heading"
              className="best-sellers-section-title text-center"
            >
              NOS MEILLEURES VENTES
            </h2>
          </header>
        </Fade>
        {isLoading ? (
          <BestSellerCatalogGrid
            products={[]}
            isLoading
            skeletonCount={4}
          />
        ) : products.length > 0 ? (
          <BestSellerCatalogGrid products={products} isLoading={false} />
        ) : (
          <p className="best-sellers-section-empty text-center mb-0">
            Aucun produit mis en avant pour le moment.
          </p>
        )}
      </div>
    </section>
  );
};

export default BestSellersSection;
